// 教师管理
export default [
  {
    path: "/teacher",
    meta: { title: "老师专家管理" },
    component: () => import("../views/teacher/index"),
    children: [
      {
        path: "/teacher/teacherList",
        name: "teacherList",
        meta: { title: "老师专家列表", isMenu: true },
        component: () => import("../views/teacher/teacherList"),
      },
    ],
  },
]
